import React from 'react';

function Breadcrumb({ breadcrumb }) {
  const angle = '<small><i class="fa fa-angle-right"></i></small>';

  if (!breadcrumb) { return null; }

  function breadcrumbHtml() {
    return breadcrumb.map((el, index) => {
      if (index === breadcrumb.length - 1) {
        return el;
      }

      return `${el}&nbsp;${angle}&nbsp;`;
    }).join('');
  }

  return (
    <div className="breadcrumb">
      <small dangerouslySetInnerHTML={{ __html: breadcrumbHtml() }}></small>
    </div>
  );
}

Breadcrumb.propTypes = {
  breadcrumb: React.PropTypes.array
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./components/breadcrumb.js